import { useBienContext } from '../BienContext'

import { Input, Spinner } from '@/components/ui'
import DetailTemplate from '@/components/DetailTemplate'
import Contact from '../Contact'
import EditButtons from '../EditButtons'
import { formatPrice, formatDate } from '@/utils/formatters'
import Form from './Form'

export default () => {
  const { bien, loading, updatedSections, markSectionAsUpdated, 
    isPendingAction, closeModalCallback
  } = useBienContext()

  const SECTION_ID = 'vente'
  const SECTION_TITLE = "Vente"

  const modalContent = <Form title={SECTION_TITLE} />
  
  const editButton = <EditButtons
    bienId={bien.id}
    isArchived={!!bien.archived_at}
    isPendingAction={isPendingAction}
    title="Modifier la section Vente"
  /> 

  return(
    <DetailTemplate
      title={SECTION_TITLE}
      sectionId={SECTION_ID}
      bodyProps={{columns: 3}}
      updatedSections={updatedSections}
      loading={false}
      isPendingAction={isPendingAction}
      editButton={editButton}
      modalContent={modalContent}
      onUpdateSuccess={markSectionAsUpdated}
      onCloseModalCallback={closeModalCallback}
    >
      <div className="space-y-4">
        <Input.Display label="Prix de vente" value={formatPrice(bien.prix_vente)} />
        <Input.Display label="Marge" value={formatPrice(bien.marge)} />
        <Input.Display label="Honoraires TTC" value={formatPrice(bien.vente_montant_honoraires_ttc)} />
        <Input.Display label="Net vendeur" value={formatPrice(bien.montant_net_vendeur)} />
      </div>
      <div className="space-y-4">
        { !loading && bien.acquereurs?.length > 0 && bien.acquereurs.map((acquereur, index) => (
          <Contact key={acquereur.id} label="Acquéreur" item={acquereur} index={index} />
        ))}
        { (!bien.acquereurs || bien.acquereurs?.length == 0 ) && (
          <Input.Display label="Acquéreurs">
            { loading && isPendingAction && (
                <Spinner color='primary'/>
            )}
          </Input.Display>
        )}
      </div>
      <div className="space-y-4">
        <Input.Display label="Notaire vendeur" value={bien.notaire_vendeur} valueClassName="uppercase" />
        <Input.Display label="Notaire acquéreur" value={bien.notaire_acquereur} valueClassName="uppercase" />
        <Input.Display label="Date compromis" value={formatDate(bien.date_signature_compromis)} />
        <Input.Display label="Date signature" value={formatDate(bien.date_signature_acte)} />
        <Input.Display label="Date relevé compteur" value={formatDate(bien.date_releve_compteur)} />
      </div>

    </DetailTemplate>
  )
}